import { BadgeNumericClickable } from '@components/badge-numeric-clickable/src/badge-numeric-clickable.type';
import { ChartData } from '@components/tremor-line-chart-wrapper/src/tremor-line-chart-wrapper.type';

export const RECHART_LAYOUT_VERTICAL = 'vertical';
export const RECHART_LAYOUT_HORIZONTAL = 'horizontal';

export interface CreatePathProps extends BarChartShape {
  acum: number;
  barBorderWidth: number;
  barGapColor: string;
  radius: number;
}

export interface BarChartShape {
  fill?: string;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
}

export interface BarchartData {
  dataKey: string;
  layout: typeof RECHART_LAYOUT_HORIZONTAL | typeof RECHART_LAYOUT_VERTICAL;
  gridColor: string;
  strokeDasharray: string;
  horizontalGridLines: boolean;
  axisLineX: boolean | object;
  tickLineX: boolean | object;
  axisLineY: boolean | object;
  tickLineY: boolean | object;
  barGapColor: string;
  barHeight: number;
  barBorderRadius: number;
  barBorderWidth: number;
  barGapY: number;
  rechartFontSizeLg: number;
  rechartFontSizeXs: number;
  rechartSubtitleFontSize: number;
}

export interface RechartsBarChartWrapperProps extends BarchartData {
  data?: ChartData[];
  barList: BadgeNumericClickable[];
  dataType: string;
  locale: string;
}

interface Payload {
  coordinate: number;
  index: number;
  isShow: boolean;
  offset: number;
  tickCoord: number;
  value: string;
}

export interface RechartsCustomTickProps {
  isMobile: boolean;
  gridColor: string;
  className: string;
  fill: string;
  height: number;
  index: number;
  orientation: string;
  payload: Payload;
  stroke: string;
  textAnchor: string;
  tickFormatter?: () => void;
  verticalAnchor: string;
  visibleTicksCount: number;
  width: number;
  x: number;
  y: number;
  percentage: number;
  total: string;
  rechartFontSizeLg: number;
  rechartFontSizeXs: number;
  rechartSubtitleFontSize: number;
}
